import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';
import { injectIntl, FormattedMessage } from 'react-intl';
import TwoKeyButton from './TwoKeyButton';
import icon from '../../icons/user_empty.svg';
import './reactivateUserModal.scss';

const ReactivateUserModal = ({
  isOpen, handleClose, handleClick, intl: { formatMessage }, loading,
}) => (
  <Modal
    className="deleted-user-modal reactivate-user"
    isOpen={!!isOpen}
    onRequestClose={handleClose}
    closeTimeoutMS={100}
    shouldCloseOnOverlayClick
    overlayClassName="flex acquisition-required"
  >
    <section className="login-required">
      <header>
        <h2>
          <FormattedMessage id="user.was_deleted" defaultMessage="!This User was Deleted" />
        </h2>
        <button className="close-btn" onClick={handleClose}>×</button>
      </header>
      <main>
        <div className="empty-user-img-wrapper">
          <img src={icon} alt="" />
        </div>
        <p>
          <FormattedMessage
            id="user.reactivate_text"
            defaultMessage="!Would you like to reactivate your deleted user?"
            values={{ br: <br /> }}
          />
        </p>
        <div className="reactivate-btn-wrapper">
          <TwoKeyButton
            loading={loading}
            text={formatMessage({ id: 'user.reactivate_btn', defaultMessage: '!Reactivate User' })}
            onClick={handleClick}
          />
        </div>
      </main>
    </section>
  </Modal>
);

ReactivateUserModal.propTypes = {
  isOpen: PropTypes.bool,
  loading: PropTypes.bool,
  intl: PropTypes.object.isRequired,
  handleClose: PropTypes.func.isRequired,
  handleClick: PropTypes.func.isRequired,
};

export default injectIntl(ReactivateUserModal);
